package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class EventTeamMatch(
    val code: String,
    val level: Schedule.Match.Level,
    val series: Int,
    val number: Int,
    val npTotal: Float,
    val total: Float,
    val auto: Float,
    val teleop: Float,
    val endgame: Float,
    val penalty: Float,
    val gameSpecific: EventTeamMatchGameSpecific? = null,
)

@Serializable
sealed class EventTeamMatchGameSpecific

@Serializable
data class EventTeamMatchFreightFrenzy(val alliance: Float, val shared: Float, val carousel: Float) : EventTeamMatchGameSpecific()

@Serializable
data class EventTeamMatchFreightFrenzyCRI(val alliance: Float, val shared: Float, val coop: Float) : EventTeamMatchGameSpecific()

@Serializable
data class EventTeamMatchIntoTheDeep(val specimen: Float, val sample: Float, val navigation: Float) : EventTeamMatchGameSpecific()

@Serializable
data class EventTeamMatchIntoTheDeepCRI(val specimen: Float, val sample: Float, val navigation: Float) : EventTeamMatchGameSpecific()
